import React, { useState } from 'react';

import TableRow from '../TableRow';
import TableData from '../TableData';
import CheckItem from './CheckItem';
import { CheckType, Column, Row } from '../component/types';
import { IconChevronDown, IconChevronRight } from '@pentabd/icons';
import ColumnCheckItem from './ColumnCheckItem';
import classNames from 'classnames';

interface Props<T> {
  row: T;
  index: number;
  trColor?: string;
  check?: CheckType;
  columns: Column<T>[];
}

function RowView<T extends Row>({
  row,
  index,
  trColor,
  check,
  columns,
}: Props<T>) {
  const [showChild, setShowChild] = useState(false);
  return (
    <>
      <TableRow className={row?.className} trColor={trColor}>
        {check && !check?.isHideCheckbox ? (
          <CheckItem<T> row={row} index={index} />
        ) : null}

        {columns?.map((column, columnIndex) =>
          column?.key && !column?.hide ? (
            <TableData
              key={columnIndex}
              className={classNames({
                'sticky-td': column?.fixedPosition,
              })}
              {...(column?.fixedPosition && {
                style: {
                  width: column?.fixedPosition?.width,
                  maxWidth: column?.fixedPosition?.width,
                  minWidth: column?.fixedPosition?.width,
                  left: column?.fixedPosition?.left,
                  right: column?.fixedPosition?.right,
                  zIndex: 500 - index,
                },
              })}
            >
              {row?.node?.length > 0 && column?.key == columns[0]?.key ? (
                <span className="d-flex align-items-center">
                  {column?.render
                    ? column?.render(row[column?.key], row)
                    : row[column?.key]}
                  <div
                    className="d-flex align-items-center pointer"
                    onClick={() => setShowChild((state) => !state)}
                  >
                    {showChild ? (
                      <IconChevronDown size={24} fill="primary" />
                    ) : (
                      <IconChevronRight size={24} fill="primary" />
                    )}
                  </div>
                </span>
              ) : column?.isCheckAble ? (
                <ColumnCheckItem<T>
                  row={row}
                  index={index}
                  column={column}
                  check={check}
                />
              ) : column?.render ? (
                column?.render(row[column?.key], row)
              ) : (
                row[column?.key]
              )}
            </TableData>
          ) : null,
        )}
      </TableRow>

      {showChild && row?.node?.length > 0
        ? row?.node?.map((item, idx) => (
            <RowView
              key={item?.id}
              row={item}
              index={idx}
              columns={columns}
              trColor="bg-primary-lighter"
              check={check}
            />
          ))
        : null}
    </>
  );
}

export default RowView;
